import React from 'react';
import { Box, Divider, Link, Text, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { ENERGY_MASTERS_TENANT_ID } from 'clipsal-cortex-utils/src/constants/common-constants';

import { ENERGY_MASTERS_EMAIL, ENERGY_MASTERS_PHONE, SUPPORT_EMAIL } from '../../../common/constants';
import { useViewportType } from '../../../common/hooks/use-viewport-type';
import { selectSite } from '../../site/siteSlice';
import { ProfilePageBase } from '../ProfilePageBase';

/*
 * This is used to display support details for Energy Masters only for now.
 */
export function SupportDetails() {
  const site = useSelector(selectSite);
  const { isDesktopViewport } = useViewportType();
  const bgColor = useColorModeValue('white', 'gray.900');
  const isEnergyMastersSite = site.tenant_id === ENERGY_MASTERS_TENANT_ID;

  return (
    <ProfilePageBase title={isEnergyMastersSite ? 'Energy Masters Support' : 'Support'}>
      <Box data-testid="support-content" px={isDesktopViewport ? 4 : 0}>
        {isEnergyMastersSite && (
          <>
            <Box bg={bgColor} px={4} py={6}>
              <Link
                href={`tel:${ENERGY_MASTERS_PHONE.replace(/\s/g, '')}`}
                style={{ textDecoration: 'none' }}
                color="customBlue.500"
                fontWeight={'bold'}
              >
                (08) {ENERGY_MASTERS_PHONE}
              </Link>
              <Text mt={2} fontSize="sm">
                Available on 9:00am-4:30pm, Mon-Fri (excluding public holidays)
              </Text>
            </Box>
            <Divider />
          </>
        )}
        <Box bg={bgColor} px={4} py={6}>
          <Link
            href={`mailto:${isEnergyMastersSite ? ENERGY_MASTERS_EMAIL : SUPPORT_EMAIL}`}
            style={{ textDecoration: 'none' }}
            color="customBlue.500"
            wordBreak={'break-all'}
            fontWeight={'bold'}
          >
            {isEnergyMastersSite ? ENERGY_MASTERS_EMAIL : SUPPORT_EMAIL}
          </Link>
        </Box>
      </Box>
    </ProfilePageBase>
  );
}
